import React, { useState } from "react";
import { ArrowLeft, Fingerprint, Radio } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ServerProtocols from "../ServerProtocols";
import ApAssetDetail from "./ApAssetDetail";
import ApBridgeTable from "./ApBridgeTable";
import ApInterfaces from "./ApInterfaces";
import ApArpTable from "./ApArpTable";

const APPage: React.FC = () => {
    const navigate = useNavigate();

    const info = JSON.parse(sessionStorage.getItem("internal_ids") || "{}");
    const asset_id = info.asset_id;
    const hostname = info.host_name || "Access Point";
    const client_id = info.client_id;

    const [fingerprintMode, setFingerprintMode] = useState(false);
    return (
        <div className={`flex flex-col gap-4 p-4 bg-slate-50 dark:bg-gray-900 text-slate-800 dark:text-slate-200 transition-all duration-500 ${fingerprintMode ? 'h-screen overflow-hidden pb-10' : 'min-h-screen'}`}>
            {/* Header Area */}
            <div className="flex items-center justify-between gap-2 flex-wrap sm:flex-nowrap border-b border-slate-200 dark:border-slate-800 pb-3">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-orange-600 rounded-lg shadow-lg shadow-orange-600/20">
                        <Radio className="w-6 h-6 text-white" />
                    </div>
                    <div>
                        <h1 className="text-xl font-bold text-gray-900 dark:text-white tracking-tight leading-none mb-1">Access Point Dashboard</h1>
                        <p className="text-[12px] text-slate-500 dark:text-slate-400 font-medium uppercase tracking-wider">Hostname : {hostname}</p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 bg-slate-100 dark:bg-slate-900/50 p-1 rounded-lg border border-slate-200 dark:border-slate-800/60 mr-2">
                        <div className={`p-1.5 rounded-md transition-colors ${fingerprintMode ? 'bg-orange-600 text-white' : 'text-slate-500 dark:text-slate-400'}`}>
                            <Fingerprint className="w-3.5 h-3.5" />
                        </div>
                        <span className="text-[10px] font-black uppercase text-slate-600 dark:text-slate-400 tracking-wider">Fingerprint</span>
                        <button
                            onClick={() => setFingerprintMode(!fingerprintMode)}
                            className={`relative inline-flex h-5 w-10 items-center rounded-full transition-all duration-300 focus:outline-none cursor-pointer ${fingerprintMode ? 'bg-orange-600' : 'bg-slate-300 dark:bg-slate-700'}`}
                        >
                            <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform duration-300 ${fingerprintMode ? 'translate-x-5.5' : 'translate-x-1'}`} />
                        </button>
                    </div>

                    <button
                        onClick={() => navigate(info.path)}
                        className="flex items-center gap-1.5 px-4 py-2 bg-orange-600 hover:bg-orange-500 dark:bg-orange-700 dark:hover:bg-orange-600 rounded-lg text-xs font-bold text-white transition-all active:scale-95 shadow-sm uppercase tracking-wide cursor-pointer"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back
                    </button>
                </div>
            </div>

            {fingerprintMode ? (
                <div className="flex-1 min-h-0 pb-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
                    <ServerProtocols hideHeader={false} />
                </div>
            ) : (
                <div className="pb-20 space-y-2">
                    <div>
                        <ApAssetDetail
                            assetId={asset_id}
                            client_id={client_id}
                        />
                    </div>
                    <div>
                        <ApBridgeTable assetId={asset_id} client_id={client_id} />
                    </div>
                    <div>
                        <ApArpTable assetId={asset_id} client_id={client_id} />
                    </div>
                    <div>
                        <ApInterfaces
                            assetId={asset_id}
                            client_id={client_id}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default APPage;

